import styled from "styled-components";

// Styling for the Card Component.
const Card = styled.div`
  // Flex container for aligning content.
  display: flex;
  justify-content: space-around; 
  align-items: center;
  // Card dimensions and appearance.
  width: 90%;
  height: 90%;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  // Responsive styles for small screens.
  @media screen and (max-width: 600px) {
    font-size: 0.5rem;
    width: 99%;
  }
`;
// Styling for the Stat Component.
const Stat = styled.div`
  //Text color for stats.
  color: #fff;
  // Flex container for aligning content.
  display: flex;
  flex-direction: column;
  text-align: center;
  // Spacing around the content.
  padding: 5px;
`;

export {Card , Stat };
